export default __webpack_public_path__ + "assets/images/0ac86d23fd7af5b48e47feda37fea1a0.png";